import { CountryEnum } from "@vini-wine/core-enums";
import { CountryDto } from "@vini-wine/core-dtos";

export interface CountryModel {
  // transform
  codeAlpha2: CountryEnum;
  codeAlpha3: string;
  codeUn: string;
}

export const createCountryDtoFromAdminCountryModel = (
  country: CountryModel,
): CountryDto => {
  return {
    codeAlpha2: country.codeAlpha2,
  };
};
